var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viu-header"},[_c('div',{staticClass:"text"},[_vm._t("default",function(){return [_vm._v("Header")]})],2),(_vm.separator)?_c('hr',{staticClass:"separator"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }